import React from "react";

import DispEffect from "./Biases/DispEffect";
import Overconfidence from "./Biases/Overconfidence";
import ProgressDemo from "./Biases/ProgressDemo";
import { useHistory } from "react-router-dom";

export default function Report() {
  const history = useHistory();

  let dispEffectPerc = "33%";
  let overconfidencePerc = "45%";

  //GSAP

  return (
    <>
      <div className="section-container dash-section flex-column">
        <section className="report-section">
          <div className="report-container">
            <h1 className="report-header">
              <span>Demo </span> <span>Report</span>
              {/* <span className="report-header-add"> (OVERALL)</span> */}
            </h1>
            <div className="report-bias-container">
              <DispEffect dispEffectPerc={dispEffectPerc} />
              <Overconfidence overconfidencePerc={overconfidencePerc} />
            </div>
          </div>
        </section>
        <ProgressDemo />
        <section id="demo-cta-section">
          <button
            className="link-text cta"
            onClick={() => {
              history.goBack();
            }}
          >
            Send me back
          </button>
        </section>
      </div>
    </>
  );
}
